import { liveBattleActionTypes } from './Constants';

const initialState = {
	loading: false,
	data: null,
	showError: false,
	loadingSendCode: false,
	enterCodeError: null,
	battleRoomData: null,
	loadingUpdateSettings: false,
	closeRoomModalData: {
		open: false,
		type: 'user',
	},
	roomSettingsModalData: {
		open: false,
		isClosingModal: true,
		disabledOptions: false,
	},
	continuePracticingModalData: {
		open: false,
		exerciseStage: 'quiz',
	},
	answerResults: [],
	answerResultsLoading: false,
	answerSummary: null,
	loadingNextQuestion: false,
};

export default function liveBattleReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, answerResults, questionId, questionAnswers, answerSummary } = payload || {};

	switch (type) {
		case liveBattleActionTypes.CREATE_LIVE_BATTLE:
			return {
				...state,
				loading: true,
			};

		case liveBattleActionTypes.CREATE_LIVE_BATTLE_SUCCESS:
			return {
				...state,
				loading: false,
				battleRoomData: data,
			};

		case liveBattleActionTypes.CREATE_LIVE_BATTLE_ERROR:
			return {
				...state,
				loading: false,
				showError: true,
			};

		case liveBattleActionTypes.GET_BATTLE_ROOM_DATA:
			return {
				...state,
				loadingSendCode: true,
			};

		case liveBattleActionTypes.GET_BATTLE_ROOM_DATA_SUCCESS:
			return {
				...state,
				battleRoomData: data,
				loadingSendCode: false,
			};

		case liveBattleActionTypes.GET_BATTLE_ROOM_DATA_ERROR:
			return {
				...state,
				enterCodeError: data,
				loadingSendCode: false,
			};

		case liveBattleActionTypes.CHANGE_BATTLE_SETTINGS:
			return {
				...state,
				loadingUpdateSettings: true,
			};

		case liveBattleActionTypes.CHANGE_BATTLE_SETTINGS_SUCCESS:
			return {
				...state,
				battleRoomData: { ...state.battleRoomData, ...data },
				loadingUpdateSettings: false,
			};

		case liveBattleActionTypes.CHANGE_BATTLE_SETTINGS_ERROR:
			return {
				...state,
				loadingUpdateSettings: false,
			};

		case liveBattleActionTypes.TOGGLE_CLOSE_ROOM_MODAL:
			return {
				...state,
				closeRoomModalData: { ...state.closeRoomModalData, ...data },
			};

		case liveBattleActionTypes.TOGGLE_ROOM_SETTINGS_MODAL:
			return {
				...state,
				roomSettingsModalData: { ...state.roomSettingsModalData, ...data },
			};
		case liveBattleActionTypes.TOGGLE_CONTINUE_PRACTICING_MODAL:
			return {
				...state,
				continuePracticingModalData: { ...state.continuePracticingModalData, ...data },
			};

		case liveBattleActionTypes.GET_ANSWER_RESULTS:
			return {
				...state,
				answerResultsLoading: true,
			};

		case liveBattleActionTypes.GET_ANSWER_RESULTS_SUCCESS:
			return {
				...state,
				answerResultsLoading: false,
				answerResults,
			};

		case liveBattleActionTypes.GO_TO_NEXT_BATTLE_SCREEN:
			return {
				...state,
				loadingNextQuestion: true,
				battleRoomData: {
					...state.battleRoomData,
					remaining_time_to_answer_in_seconds: null,
				},
			};

		case liveBattleActionTypes.GO_TO_NEXT_BATTLE_SCREEN_SUCCESS:
		case liveBattleActionTypes.GO_TO_NEXT_BATTLE_SCREEN_ERROR:
			return {
				...state,
				loadingNextQuestion: false,
			};

		case liveBattleActionTypes.GET_QUESTION_ANSWERS:
			const formattedAnswersWithLoading = state.answerResults.map((item) => {
				if (item.id === questionId) {
					return { ...item, loading: true };
				}
				return item;
			});

			return {
				...state,
				answerResults: formattedAnswersWithLoading,
			};

		case liveBattleActionTypes.GET_QUESTION_ANSWERS_SUCCESS:
			const formattedAnswers = state.answerResults.map((item) => {
				if (item.id === questionId) {
					return { ...item, loading: false, question: questionAnswers };
				}
				return item;
			});

			return {
				...state,
				answerResults: formattedAnswers,
			};

		case liveBattleActionTypes.GET_QUESTION_ANSWERS_ERROR:
			const formattedAnswersWithLoadingFailed = state.answerResults.map((item) => {
				if (item.id === questionId) {
					return { ...item, loading: false };
				}
				return item;
			});

			return {
				...state,
				answerResults: formattedAnswersWithLoadingFailed,
			};

		case liveBattleActionTypes.SET_LIVE_BATTLE_ANSWER_SUMMARY:
			return {
				...state,
				answerSummary,
			};

		case liveBattleActionTypes.CLEAR_LIVE_BATTLE_STATE:
			return initialState;

		case liveBattleActionTypes.CLEAR_REMAINING_TIME:
			return {
				...state,
				battleRoomData: {
					...state.battleRoomData,
					remaining_time_to_answer_in_seconds: null,
				},
			};

		case liveBattleActionTypes.CLEAR_ANSWER_SUMMARY:
			return {
				...state,
				answerSummary: null,
			};

		default:
			return state;
	}
}
